import AwardedBestAnswerNotification from './AwardedBestAnswerNotification';
import BestAnswerBadge from './BestAnswerBadge';
import BestAnswerFooterPreview from './BestAnswerFooterPreview';
import BestAnswerInDiscussionNotification from './BestAnswerInDiscussionNotification';
import SelectBestAnswerItem from './SelectBestAnswerItem';
import SelectBestAnswerNotification from './SelectBestAnswerNotification';
import SolutionSearchItem from './SolutionSearchItem';
import SolutionSearchSource from './SolutionSearchSource';

export const components = {
  SelectBestAnswerItem,
  SolutionSearchSource,
  BestAnswerFooterPreview,
  AwardedBestAnswerNotification,
  BestAnswerBadge,
  BestAnswerInDiscussionNotification,
  SelectBestAnswerNotification,
  SolutionSearchItem,
};
